module.exports = __webpack_public_path__ + "static/media/icon_youtube.c11cca47.svg";